import { faFolder } from "@fortawesome/pro-solid-svg-icons"
import { TextField } from "@mui/material"
import { useFormikContext } from "formik"
import { useEffect, useRef } from "react"
import { ICustomerCustomRole, ICustomerCustomRoleForm, ICustomRoleFormInputProps } from "./customercustomrole.interface"
import { roleValidationSchema } from "./roleValidationSchema"
import { Sidebar } from "components/sidedrawer/Sidebar2";
import { StyledListItem, StyledListItemText } from "shared/styled/General"

const CustomRoleFormInput: React.FC<ICustomRoleFormInputProps> = ({ t }) => {
  const { values, handleChange, handleBlur, touched, errors } = useFormikContext<ICustomerCustomRole>()

  return (
    <StyledListItem>
      <StyledListItemText
        style={{ paddingBottom: "8px", display: "flex", gap: "4px", alignItems: "center" }}
        primary={t("global.role", "Role")}
      />
      <TextField
        autoComplete="off"
        fullWidth
        id="name"
        value={values.name}
        placeholder={t("settings.customer.enter_role_name", "Enter role name")}
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched.name && errors.name ? true : false}
        helperText={touched.name && errors.name ? t("global.name_is_required", "Name is required") : null}
        variant="outlined"
      />
    </StyledListItem>
  )
}

const CustomRoleForm = (props: ICustomerCustomRoleForm) => {
  const { initialFormikValues, setInitialFormikValues, results, handleSubmit, t } = props
  const formRef = useRef<any>(null)

  useEffect(() => {
    if (results.status === 2 && formRef.current) {
      formRef?.current?.resetForm()
    }
  }, [results])

  return (
    <Sidebar
      initialFormikValues={initialFormikValues}
      setInitialFormikValues={setInitialFormikValues}
      validationSchema={roleValidationSchema}
      formResult={results}
      handleSubmit={handleSubmit}
      formData={{
        formId: "CustomRoleForm",
        titleNew: t("global.add_role", "Add role"),
        titleEdit: t("global.update_role", "Update role"),
        subTitleNew: t("settings.customer.enter_role_name", "Enter role name"),
        subTitleEdit: t("settings.customer.update_name_on_role", "Update role name"),
        submitText: t("global.create_role", "Create role"),
        submitEditText: t("global.save", "Save"),
        icon: faFolder,
      }}
      formRef={formRef}
    >
      <CustomRoleFormInput t={t} />
    </Sidebar>
  )
}
export default CustomRoleForm
